import React, { Component } from 'react';

const SecondarySubtitle = ({ children }) => (
  <h3 className="secondary-subtitle">{children}</h3>
)

export default SecondarySubtitle;
